/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Player_Video_Player_Aria_LabelInputs */

const en_player_video_player_aria_label = /** @type {(inputs: Player_Video_Player_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Video player`)
};

const fr_player_video_player_aria_label = /** @type {(inputs: Player_Video_Player_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lecteur video`)
};

const de_player_video_player_aria_label = /** @type {(inputs: Player_Video_Player_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Videoplayer`)
};

const it_player_video_player_aria_label = /** @type {(inputs: Player_Video_Player_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lettore video`)
};

const ru_player_video_player_aria_label = /** @type {(inputs: Player_Video_Player_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Видеоплеер`)
};

const es_player_video_player_aria_label = /** @type {(inputs: Player_Video_Player_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reproductor de video`)
};

const zh_cn2_player_video_player_aria_label = /** @type {(inputs: Player_Video_Player_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`视频播放器`)
};

const ja_player_video_player_aria_label = /** @type {(inputs: Player_Video_Player_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ビデオプレーヤー`)
};

const hi_player_video_player_aria_label = /** @type {(inputs: Player_Video_Player_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`वीडियो प्लेयर`)
};

const pt_pt2_player_video_player_aria_label = /** @type {(inputs: Player_Video_Player_Aria_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reprodutor de vídeo`)
};

/**
* | output |
* | --- |
* | "Video player" |
*
* @param {Player_Video_Player_Aria_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const player_video_player_aria_label = /** @type {((inputs?: Player_Video_Player_Aria_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Player_Video_Player_Aria_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_player_video_player_aria_label(inputs)
	if (locale === "de") return de_player_video_player_aria_label(inputs)
	if (locale === "it") return it_player_video_player_aria_label(inputs)
	if (locale === "ru") return ru_player_video_player_aria_label(inputs)
	if (locale === "es") return es_player_video_player_aria_label(inputs)
	if (locale === "zh-CN") return zh_cn2_player_video_player_aria_label(inputs)
	if (locale === "ja") return ja_player_video_player_aria_label(inputs)
	if (locale === "hi") return hi_player_video_player_aria_label(inputs)
	if (locale === "pt-PT") return pt_pt2_player_video_player_aria_label(inputs)
	return en_player_video_player_aria_label(inputs)
});